export default __webpack_public_path__ + "images/GF.0d30341.png";